module.exports = __webpack_public_path__ + "img/003.8fa54c7c.jpg";